<template>
	<div class="footer">
		<div class="hyperlink">
			<div class="groups" v-for='(item,index) in topMenus' :class='index == 1 ? "ms-groups":""' :key='item.Code'>
				<a v-if='item.Href' class="link" @click='href(item)'>{{item.Label}}</a>
				<div class="link" v-else-if='item.Label || item.LabelEN'>{{item.Label}}&nbsp;&nbsp;{{item.LabelEN}}</div>
				<template v-for='item1 in item.Childs'>
					<a :key='item1.Code+1' v-if='item1.Href' class="link" @click='href(item1)' >{{item1.Label}}&nbsp;&nbsp;{{item1.LabelEN}}{{item1.Description ? '：'+ item1.Description :'' }}</a>
					<div :key='item1.Code+2' v-else class="link">{{item1.Label}}&nbsp;&nbsp;{{item1.LabelEN}}{{item1.Description ? '：'+ item1.Description :'' }}</div>
				</template>
				<div v-if='index == 1' class="media">
					<a class="app">
			  			<img class="icon" src="@/assets/appicon.png">
			  			<div class="qrcode">
			  				<img src="http://doc.doterra.cn/uploads/WebSite/Contact/appqrcode1.jpeg">
			  			</div>
			  		</a>
					<a class="wechat">
			  			<img class="icon" src="@/assets/wechat.png">
			  			<div class="qrcode">
			  				<img src="https://cdn.dohwg.cn/images/sys/website/wechatqrcode.png">
			  			</div>
			  		</a>
			  		<a href="https://weibo.com/u/6581493709">
			  			<img class="icon" src="@/assets/weibo.png">
			  		</a>
			  		<a href="https://www.xiaohongshu.com/user/profile/5cc163d1000000001102a72f?xhsshare=CopyLink&appuid=5cc163d1000000001102a72f&apptime=1578995925">
			  			<img class="icon" src="@/assets/xiaohongshu.png">
			  		</a>
				</div>
			</div>
			<div class="groups">
				<p>© 2020 多特瑞（上海）商贸有限公司所有</p>
				<p style="margin-bottom: 10px;color: #999;">版权为未经许可不得转载或链接</p>
				<a style="margin-bottom: 0" class="link" href="http://doterra.cn/">http://doterra.cn/</a>
				<p style="margin-bottom: 10px;color: #999;"><a style="color: #999;text-decoration: underline;" href="https://beian.miit.gov.cn">沪ICP备14052891号-1</a></p>
				<p style="margin-bottom: 10px;"><a class="link" style="margin-bottom: 0" href="https://cvo.doterra.cn/vo/index.html#/privacy">隐私政策</a></p>
		  		<p style="display: flex;">
		  			<a  style="margin-right: 10px;" target="_blank" class="link" href="http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020200407140014000005690366-SAIC_SHOW_310000-4028e4c74c2738a7014d231313770c67538&signData=MEYCIQDy93PrjuKzF/uKJ5f+bmPKMz2FGjlYzGG4uZoyAv4/2AIhAK/9B4FSZaCjnaRiuXMsshUDOcNwLb6vzaXS3eKupSR9"><img style='width:31px;height: 37px;' src="@/assets/china_bc_icon.jpg"></a>
					<a style="display: flex;align-items: center;" target="_blank" class="link" href="https://beian.miit.gov.cn"><img  src="@/assets/record.png"><p style="color: #999;margin-left: 10px;font-size: 0.13rem;">沪公网安备 31010602004501号</p></a>
		  		</p>
			</div>
		</div>
		<div class="policys">
			<template v-for='(item,index) in bottomMenus'>
				<a :key='item.Code' class="link" @click='href(item)' :href="item.Href"  >{{item.Label}}</a><div v-if='index < bottomMenus.length - 1'>|</div>
			</template>
		</div>
		 <Modal v-model="showModal" :closable='false' footer-hide>
        	<div class="modal-content">
        		<div v-html='modalContent.Content'></div>
        	</div>
	    </Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import {
		ssoUrl,
		baseUrl,
		cvoUrl
	} from '@/config/env'
	import util from '@/config/util'
	export default {
		data() {
			return {
				showModal:false,
				modalContent:{},
			}
		},
		props:{
			menus:{
				default:[],
				type:Array,
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({
				token: state => state.common.userToken,
			}),
			topMenus(){
				return this.menus.filter(item=>item.MenuFlag == 20)
			},
			bottomMenus(){
				return this.menus.filter(item=>item.MenuFlag == 21)
			}
		},
		methods: {
			...mapActions([
				'getCommunityArticleAction',
			]),
			async initData(){

			},
			href(item){		
				let url = item.Href;
				if (this.token && url.indexOf('http') == 0 && url.indexOf(baseUrl) != 0) {
					url += `?token=${this.token}`;
				}
				if (url.indexOf('http') == 0) {
					window.open(url);
				} else if(url.indexOf('action://') == 0){
					let actionUrl = url.split('action://')[1]
					console.log(actionUrl)
					let [action, ...query] = actionUrl.split('?');
					query = query.join('?')
					let queryObj = {}
					if (query) {
						let queryArray = query.split('&')
						queryArray.forEach(item => {
								let [key, ...value] = item.split('=')
								queryObj[key] = value.join('=')
						});
					}
					this[action]&&this[action](queryObj)

				} else {
					location = url
				}
			},
			async showArticle({Code}){
				this.modalContent = await this.getCommunityArticleAction({Code})
				this.showModal = true
			},
		},
	}
</script>

<style lang='scss' scoped>
@import '@/style/mixin';
	.hyperlink {
		display: flex;
		border-top: 1px solid #eee;
		border-bottom: 1px solid #eee;
		padding-top: 3.13vw;
		justify-content: space-around;
		.groups {
			// margin-left: 10.42vw;
			.icon {
				width: 30px;
				height: 30px;
				margin-right: 10px;
			}
		}
		.link {
			display: block;
			color: #666;
			// text-align: center;
			margin-bottom: 0.2rem;
		}
		a:hover {
			color:$theme-color;
		}
	}
	.media {
		position: relative;
		.wechat:hover,.app:hover {
			.qrcode {
				display:block;
			}
		}
		.qrcode {
			display: none;
			width:350px;
			position: absolute;
			bottom: 40px;
			left: -120px;
			box-shadow: 3px 3px 5px 1px rgba(0,0,0,.2);
			img {
				display: block;
				max-width: 100%;
			}
		}
		.app {
			.qrcode{
				width:250px;
				left: -110px;
			}
			
		}
	}
	.policys {
		display: flex;
		justify-content: center;
		margin-top: 30px;
		margin-bottom: 50px;
		a:hover {
			color:$theme-color;
		}
		a,div {
			color: #666;
			display: block;
			padding: 0 5px;
		}
	}
	@media (max-width: 768px){
		.hyperlink {
			flex-direction: column;
			padding: 20px;
			@include fontSize($font-size-12);
			.ms-groups {
				display:flex;
				flex-wrap: wrap;
				justify-content: space-between;
				.media {
					display:block;
					width:100%;
					display:flex;
						.qrcode {
							width:200px;
							left: 0;
						}
					// justify-content: center;
				}
			}
		}
	}
</style>